module.exports = __webpack_public_path__ + "static/media/book-icon.8b277b2b.svg";